// Map related helpers: country detection + map URL builder
// Pure functions extracted from FullscreenPoiModal, parameterized to avoid Platform dependency.

export const isChinaByLocation = (loc?: any, lat?: number, lng?: number, addr?: string): boolean => {
  try {
    if (loc && typeof loc === 'object') {
      const country = String(loc.country || loc.nation || '').trim();
      if (country.includes('中国') || country.includes('中國') || country.toUpperCase() === 'CN') return true;
    }
    if (typeof addr === 'string' && /中国|中國|省|市|区|縣|區/.test(addr)) return true;
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      if ((lat as number) >= 18 && (lat as number) <= 54 && (lng as number) >= 73 && (lng as number) <= 135) return true;
    }
  } catch {}
  return false;
};

export interface MapUrlParams { title?: string; address?: string; lat?: number; lng?: number; location?: any; }
export interface BuiltMapUrl { deep?: string; web?: string; }

export const buildMapUrl = (params: MapUrlParams, platformOS: string): BuiltMapUrl | undefined => {
  const { title, address, lat, lng, location } = params || {};
  const isCN = isChinaByLocation(location, lat, lng, address);
  if (isCN) {
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      const pos = `${lng},${lat}`;
      return {
        deep: `amapuri://marker?position=${encodeURIComponent(pos)}&name=${encodeURIComponent(title || address || '目的地')}`,
        web: `https://uri.amap.com/marker?position=${encodeURIComponent(pos)}&name=${encodeURIComponent(title || address || '目的地')}`,
      };
    }
    const q = encodeURIComponent(title || address || '目的地');
    return { web: `https://uri.amap.com/search?keyword=${q}` };
  }
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    const q = `${lat},${lng}`;
    return {
      deep: platformOS !== 'web' ? `comgooglemaps://?q=${encodeURIComponent(q)}` : undefined,
      web: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`,
    };
  }
  const q = [title, address].filter(Boolean).join(' ');
  if (!q) return undefined;
  return { web: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}` };
};
